import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { ApplicationState, AppState } from '../../../../store';
import { withSnackbar, ProviderContext } from 'notistack';
import { ITranslatorService } from '../../../../services/Interfaces/ITranslatorService';
import { ApplicationContext, AppContext } from '../../../../context/Contexts';
import {
  Tooltip,
  Box,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  Grid,
  Typography,
  DialogContent,
  TextField,
  CircularProgress,
  Checkbox,
  FormControlLabel
} from '@material-ui/core';
import { ScaleLoader } from 'react-spinners';
import AddCircleTwoToneIcon from '@material-ui/icons/AddCircleTwoTone';
import AddIcon from '@material-ui/icons/Add';
import { RouteComponentProps } from 'react-router';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MUIDataTable, {
  SelectableRows,
  MUIDataTableMeta,
  MUIDataTableColumnOptions
} from 'mui-datatables';
import { MUITranslations } from '../../../../helpers/MUITableTranslations';
import CloseIcon from '@material-ui/icons/Close';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import { GTOperationEnum, LanguageCode, RefConstants } from '../../../../helpers/Constants';
import { CloudDownloadOutlined } from '@material-ui/icons';
import FileSaver from 'file-saver';
import { ICaseService } from '../../../../services/Interfaces/ICaseService';
import { IOrganizationService } from '../../../../services/Interfaces/IOrganizationService';
import { IReferential } from '../../../../interfaces/IReferential';
import moment from 'moment';
import DamageReferentialLabel from '../../../_shared/DamageReferentialLabel';
import { IReferentialService } from '../../../../services/Interfaces/IReferentialService';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import {
  PartMappingDamageSeverityDto,
  PartMappingDamageTypeDto,
  PartMappingDto,
  PartMappingFilterRequestDto,
  SavePartMappingResponseDto
} from '../../../../interfaces/Organization';
import CloudUploadOutlined from '@material-ui/icons/CloudUploadOutlined';
import NumberFormat from 'react-number-format';
import PartMappingImport from './PartMappingImport';

interface IPartMappingListState {
  newPartMapping: PartMappingDto;
  partMappingList: PartMappingDto[];
  isLoading: boolean;
  isExporting: boolean;
  page: number;
  pageSize: number;
  count: number;
  selectedBodyTypes: IReferential[];
  selectedParts: IReferential[];
  selectedDamageTypes: IReferential[];
  selectedOperations: IReferential[];
  selectedDamageSeverities: IReferential[];
  isDialogOpen: boolean;
  newPartMappingId: number | null;
  bodyTypeList: IReferential[];
  partList: IReferential[];
  damageTypeList: IReferential[];
  damageSeverityList: IReferential[];
  operationList: IReferential[];
  isImportDialogOpen: boolean;
  isReadOnly: boolean;
  isSaving: boolean;
}
type IPartMappingListProps = { appState: AppState } & ProviderContext &
  RouteComponentProps<{ id: string }>;
class PartMappingList extends React.PureComponent<IPartMappingListProps, IPartMappingListState> {
  private translatorService!: ITranslatorService;
  private caseService!: ICaseService;
  private organizationService!: IOrganizationService;
  private appReferentialService!: IReferentialService;
  static contextType = ApplicationContext;
  private newPartMapping = {
    id: 0,
    organizationId: 0,
    bodyTypeId: null,
    partId: null,
    parentPartMappingId: null,
    damageTypes: []
  } as PartMappingDto;

  state = {
    partMappingList: [],
    isLoading: false,
    isExporting: false,
    page: 0,
    pageSize: 10,
    count: 0,
    selectedBodyTypes: [] as IReferential[],
    selectedParts: [] as IReferential[],
    selectedDamageTypes: [] as IReferential[],
    selectedOperations: [] as IReferential[],
    selectedDamageSeverities: [] as IReferential[],
    isDialogOpen: false,
    newPartMapping: this.newPartMapping,
    newPartMappingId: null,
    bodyTypeList: [] as IReferential[],
    partList: [] as IReferential[],
    damageTypeList: [] as IReferential[],
    damageSeverityList: [] as IReferential[],
    operationList: [] as IReferential[],
    isImportDialogOpen: false,
    isReadOnly: false,
    isSaving: false
  } as IPartMappingListState;

  private get organizationId(): number {
    return Number.parseInt(this.props.match.params.id);
  }

  public componentDidMount() {
    this.setState(
      {
        isLoading: true
      },
      async () => {
        await this.loadData();
      }
    );
  }

  private buildFilter = (page: number, pageSize: number | null): PartMappingFilterRequestDto => {
    return {
      organizationId: this.organizationId,
      bodyTypeIds: this.state.selectedBodyTypes.map((item: IReferential) => item.id),
      partIds: this.state.selectedParts.map((item: IReferential) => item.id),
      damageTypeIds: this.state.selectedDamageTypes.map((item: IReferential) => item.id),
      operationIds: this.state.selectedOperations.map((item: IReferential) => item.id),
      damageSeverityIds: this.state.selectedDamageSeverities.map((item: IReferential) => item.id),
      onlyParents: false,
      page: page + 1,
      pageSize: pageSize,
      paginate: pageSize !== null,
      language: this.props.appState.language == LanguageCode.RO ? LanguageCode.RO : LanguageCode.EN
    } as PartMappingFilterRequestDto;
  };

  loadData = async () => {
    const { bodyTypeRef, gtPartRef, damageTypeRef, damageSeverityRef, operationRef } = RefConstants;

    try {
      const [
        bodyTypeList,
        partList,
        damageTypeList,
        damageSeverityList,
        operationList,
        response
      ] = await Promise.all([
        this.appReferentialService.Get(bodyTypeRef!.baseUrl),
        this.appReferentialService.Get(gtPartRef!.baseUrl),
        this.appReferentialService.Get(damageTypeRef!.baseUrl),
        this.appReferentialService.Get(damageSeverityRef!.baseUrl),
        this.appReferentialService.Get(operationRef!.baseUrl),
        this.organizationService.GetPartMappingList(
          this.buildFilter(this.state.page, this.state.pageSize)
        )
      ]);

      this.setState({
        partMappingList: response.partMappings,
        count: response.total,
        page: response.page - 1,
        isLoading: false,
        newPartMapping: { ...this.newPartMapping, organizationId: this.organizationId },
        bodyTypeList: bodyTypeList.filter((item: IReferential) => !item.isFleet),
        partList: partList,
        damageTypeList: damageTypeList,
        damageSeverityList: damageSeverityList,
        operationList: operationList
      });
    } catch (error) {
      this.showLoadError(error);
    }
  };

  reloadPartMappings = async (page: number, pageSize: number) => {
    this.setState({ isLoading: true });

    try {
      const response = await this.organizationService.GetPartMappingList(
        this.buildFilter(page, pageSize)
      );

      this.setState({
        partMappingList: response.partMappings,
        count: response.total,
        page: response.page - 1,
        pageSize: pageSize,
        isLoading: false
      });
    } catch (error) {
      this.showLoadError(error);
    }
  };

  showLoadError = (error: any) => {
    const message =
      error?.response?.status === 403
        ? this.translatorService.Tranlate(
            'PART_MAPPING_FORBIDDEN_MSG',
            'Nu aveți acces la maparea pieselor acestei organizații!'
          )
        : this.translatorService.Tranlate('ERROR_MSG', 'Eroare');
    this.props.enqueueSnackbar(message, { variant: 'error' });
    this.setState({ partMappingList: [], isLoading: false });
  };

  handleBodyTypesChange = (newValue: IReferential[]) => {
    this.setState(
      { selectedBodyTypes: newValue, isLoading: true, page: 0 },
      async () => await this.reloadPartMappings(0, this.state.pageSize)
    );
  };

  handlePartsChange = (newValue: IReferential[]) => {
    this.setState(
      { selectedParts: newValue, isLoading: true, page: 0 },
      async () => await this.reloadPartMappings(0, this.state.pageSize)
    );
  };

  handleDamageTypesChange = (newValue: IReferential[]) => {
    this.setState(
      { selectedDamageTypes: newValue, isLoading: true, page: 0 },
      async () => await this.reloadPartMappings(0, this.state.pageSize)
    );
  };

  handleOperationsChange = (newValue: IReferential[]) => {
    this.setState(
      { selectedOperations: newValue, isLoading: true, page: 0 },
      async () => await this.reloadPartMappings(0, this.state.pageSize)
    );
  };

  handleDamageSeveritiesChange = (newValue: IReferential[]) => {
    this.setState(
      { selectedDamageSeverities: newValue, isLoading: true, page: 0 },
      async () => await this.reloadPartMappings(0, this.state.pageSize)
    );
  };

  handleExport = async () => {
    this.setState({ isExporting: true });
    try {
      const blob = await this.organizationService.GetPartMappingExport(
        this.buildFilter(this.state.page, null)
      );
      FileSaver.saveAs(
        blob,
        `${this.translatorService.Tranlate('PART_MAPPING_EXPORT_FILE_NAME', 'Mapare piese')}.xlsx`
      );
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    } finally {
      this.setState({ isExporting: false });
    }
  };

  renderDamageSeverity = (damageSeverity: IReferential) => (
    <DamageReferentialLabel
      displayName={damageSeverity.displayName}
      displayDescription={damageSeverity.displayDescription}
      level={damageSeverity.level}
    />
  );

  getDamageTypeName = (damageSeverity: IReferential) =>
    this.state.damageTypeList.find((item: IReferential) => item.id === damageSeverity.dependencyId)
      ?.displayName ?? '';

  renderFilters = () => {
    // the severities follow the selected damage types; all of them when none is selected
    const damageSeverityOptions =
      this.state.selectedDamageTypes.length === 0
        ? this.state.damageSeverityList
        : this.state.damageSeverityList.filter((item: IReferential) =>
            this.state.selectedDamageTypes.some(
              (damageType: IReferential) => damageType.id === item.dependencyId
            )
          );

    return (
      <div className="mt-3">
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Box mb={2}>
              <Autocomplete
                id="bodyTypeFilter"
                multiple
                options={this.state.bodyTypeList}
                value={this.state.selectedBodyTypes}
                onChange={(e: any, newValue: any) => this.handleBodyTypesChange(newValue)}
                getOptionLabel={(option: IReferential) => option.displayName || ''}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="bodyTypeFilter"
                    label={this.translatorService.Tranlate(
                      'PART_MAPPING_BODY_TYPE_LABEL',
                      'Caroserie'
                    )}
                    fullWidth
                  />
                )}
              />
            </Box>
            <Box mb={2}>
              <Autocomplete
                id="operationFilter"
                multiple
                options={this.state.operationList}
                value={this.state.selectedOperations}
                onChange={(e: any, newValue: any) => this.handleOperationsChange(newValue)}
                getOptionLabel={(option: IReferential) => option.displayName || ''}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="operationFilter"
                    label={this.translatorService.Tranlate(
                      'PART_MAPPING_OPERATION_LABEL',
                      'Operație'
                    )}
                    fullWidth
                  />
                )}
              />
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box mb={2}>
              <Autocomplete
                id="partFilter"
                multiple
                options={this.state.partList}
                value={this.state.selectedParts}
                onChange={(e: any, newValue: any) => this.handlePartsChange(newValue)}
                getOptionLabel={(option: IReferential) => option.displayName || ''}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="partFilter"
                    label={this.translatorService.Tranlate('PART_MAPPING_PART_LABEL', 'Piesă')}
                    fullWidth
                  />
                )}
              />
            </Box>
            <Box mb={2}>
              <Autocomplete
                id="damageSeverityFilter"
                multiple
                options={damageSeverityOptions}
                value={this.state.selectedDamageSeverities}
                onChange={(e: any, newValue: any) => this.handleDamageSeveritiesChange(newValue)}
                groupBy={(option: IReferential) => this.getDamageTypeName(option)}
                getOptionLabel={(option: IReferential) =>
                  `${option.displayName || ''} (${this.getDamageTypeName(option)})`
                }
                renderOption={(option: IReferential) => this.renderDamageSeverity(option)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="damageSeverityFilter"
                    label={this.translatorService.Tranlate(
                      'PART_MAPPING_DAMAGE_SEVERITY_LABEL',
                      'Severitate'
                    )}
                    fullWidth
                  />
                )}
              />
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box mb={2}>
              <Autocomplete
                id="damageTypeFilter"
                multiple
                options={this.state.damageTypeList}
                value={this.state.selectedDamageTypes}
                onChange={(e: any, newValue: any) => this.handleDamageTypesChange(newValue)}
                getOptionLabel={(option: IReferential) => option.displayName || ''}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="damageTypeFilter"
                    label={this.translatorService.Tranlate(
                      'PART_MAPPING_DAMAGE_TYPE_LABEL',
                      'Tip daună'
                    )}
                    fullWidth
                  />
                )}
              />
            </Box>
          </Grid>
        </Grid>
      </div>
    );
  };

  private handleBodyTypeChange = (newValue: IReferential | null) => {
    this.setState({
      newPartMapping: {
        ...this.state.newPartMapping,
        bodyTypeId: newValue !== null ? newValue!.id : null
      }
    });
  };

  private handlePartChange = (newValue: IReferential | null) => {
    this.setState({
      newPartMapping: {
        ...this.state.newPartMapping,
        partId: newValue !== null ? newValue!.id : null
      }
    });
  };

  private updateDamageType = (index: number, changes: Partial<PartMappingDamageTypeDto>) => {
    const damageTypes = this.state.newPartMapping.damageTypes.map(
      (item: PartMappingDamageTypeDto, itemIndex: number) =>
        itemIndex === index ? { ...item, ...changes } : item
    );

    this.setState({ newPartMapping: { ...this.state.newPartMapping, damageTypes: damageTypes } });
  };

  private handleAddDamageType = () => {
    const damageType: PartMappingDamageTypeDto = {
      id: 0,
      damageTypeId: null,
      operationId: null,
      time: null,
      damageSeverities: []
    };

    this.setState({
      newPartMapping: {
        ...this.state.newPartMapping,
        damageTypes: [...this.state.newPartMapping.damageTypes, damageType]
      }
    });
  };

  private handleRemoveDamageType = (index: number) => {
    this.setState({
      newPartMapping: {
        ...this.state.newPartMapping,
        damageTypes: this.state.newPartMapping.damageTypes.filter(
          (item: PartMappingDamageTypeDto, itemIndex: number) => itemIndex !== index
        )
      }
    });
  };

  private handleDamageTypeChange = (index: number, newValue: IReferential | null) => {
    this.updateDamageType(index, {
      damageTypeId: newValue !== null ? newValue!.id : null,
      time: null,
      damageSeverities: []
    });
  };

  private handleOperationChange = (index: number, newValue: IReferential | null) => {
    const operationId = newValue !== null ? newValue!.id : null;
    if (this.isRepairOperation(operationId)) {
      this.updateDamageType(index, { operationId: operationId });
      return;
    }

    const damageType = this.state.newPartMapping.damageTypes[index];
    this.updateDamageType(index, {
      operationId: operationId,
      time: null,
      damageSeverities: damageType.damageSeverities.map((item: PartMappingDamageSeverityDto) => ({
        ...item,
        time: null
      }))
    });
  };

  private handleDamageTypeTimeChange = (index: number, value: string) => {
    this.updateDamageType(index, { time: this.parseTime(value) });
  };

  private handleDamageSeverityToggle = (index: number, damageSeverityId: number, checked: boolean) => {
    const damageType = this.state.newPartMapping.damageTypes[index];
    const damageSeverities = checked
      ? [...damageType.damageSeverities, { id: 0, damageSeverityId: damageSeverityId, time: null }]
      : damageType.damageSeverities.filter(
          (item: PartMappingDamageSeverityDto) => item.damageSeverityId !== damageSeverityId
        );

    this.updateDamageType(index, { damageSeverities: damageSeverities });
  };

  private handleDamageSeverityTimeChange = (index: number, damageSeverityId: number, value: string) => {
    const damageType = this.state.newPartMapping.damageTypes[index];
    const damageSeverities = damageType.damageSeverities.map((item: PartMappingDamageSeverityDto) =>
      item.damageSeverityId === damageSeverityId ? { ...item, time: this.parseTime(value) } : item
    );

    this.updateDamageType(index, { damageSeverities: damageSeverities });
  };

  private parseTime = (value: string) => {
    const num = value === '' || value === undefined ? null : parseFloat(value);

    return num !== null && !isNaN(num) ? num : null;
  };

  private NumberFormatCustom = (numberProps: any) => {
    const { inputRef, onChange, ...other } = numberProps;
    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values: any) => {
          onChange({
            target: { value: values.value },
            currentTarget: { value: values.value }
          });
        }}
        allowNegative={false}
        thousandSeparator={false}
        decimalScale={2}
      />
    );
  };

  private getTypeSeverities = (damageTypeId: number | null) =>
    this.state.damageSeverityList.filter((item: IReferential) => item.dependencyId === damageTypeId);

  private isRepairOperation = (operationId: number | null) =>
    this.state.operationList.find((item: IReferential) => item.id === operationId)?.code ===
    GTOperationEnum.RE;

  public savePartMapping = async () => {
    const validationError = this.validatePartMapping();
    if (validationError !== null) {
      this.showError(validationError);
      return;
    }

    this.setState({ isSaving: true });
    try {
      const response = await this.persistPartMapping(this.buildSaveRequest());
      if (!response.success) {
        this.showError(this.getSaveErrorMessage(response.message));
        return;
      }

      await this.onPartMappingSaved();
    } catch (error) {
      this.showError(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'));
    } finally {
      this.setState({ isSaving: false });
    }
  };

  private validatePartMapping = (): string | null => {
    const { damageTypes } = this.state.newPartMapping;
    if (damageTypes.length === 0) {
      return this.translatorService.Tranlate(
        'PART_MAPPING_DAMAGE_TYPE_REQUIRED',
        'Adaugă cel puțin un tip de daună'
      );
    }

    const missingSeverities = damageTypes.some(
      (item: PartMappingDamageTypeDto) =>
        this.getTypeSeverities(item.damageTypeId).length > 0 && item.damageSeverities.length === 0
    );
    if (missingSeverities) {
      return this.translatorService.Tranlate(
        'PART_MAPPING_DAMAGE_SEVERITY_REQUIRED',
        'Alege cel puțin o severitate pentru fiecare tip de daună cu severități'
      );
    }

    return null;
  };

  private buildSaveRequest = (): PartMappingDto => {
    const { newPartMapping } = this.state;

    return {
      ...newPartMapping,
      organizationId: this.organizationId,
      damageTypes: newPartMapping.damageTypes.map((item: PartMappingDamageTypeDto) =>
        this.buildSaveDamageType(item)
      )
    };
  };

  private buildSaveDamageType = (damageType: PartMappingDamageTypeDto): PartMappingDamageTypeDto => {
    const isRepair = this.isRepairOperation(damageType.operationId);
    const hasSeverities = damageType.damageSeverities.length > 0;

    return {
      ...damageType,
      time: isRepair && !hasSeverities ? damageType.time : null,
      damageSeverities: damageType.damageSeverities.map((item: PartMappingDamageSeverityDto) => ({
        ...item,
        time: isRepair ? item.time : null
      }))
    };
  };

  private persistPartMapping = (request: PartMappingDto): Promise<SavePartMappingResponseDto> =>
    this.state.newPartMappingId === null
      ? this.organizationService.AddPartMapping(request)
      : this.organizationService.UpdatePartMapping(request);

  private onPartMappingSaved = async () => {
    await this.reloadPartMappings(this.state.page, this.state.pageSize);
    this.closeDialog();
    this.showSuccess();
  };

  private getSaveErrorMessage = (message: string) => {
    switch (message) {
      case 'DUPLICATE_PART_MAPPING':
        return this.translatorService.Tranlate(
          'PART_MAPPING_EXISTS',
          'Maparea introdusa exista deja in lista'
        );
      case 'TIME_REQUIRED':
        return this.translatorService.Tranlate(
          'PART_MAPPING_TIME_POSITIVE',
          'Timpul trebuie să fie mai mare decât 0'
        );
      case 'PART_HAS_COMPONENTS':
        return this.translatorService.Tranlate(
          'PART_MAPPING_HAS_COMPONENTS',
          'Piesa are componente și nu poate fi ștearsă'
        );
      default:
        return this.translatorService.Tranlate(message, message);
    }
  };

  private showError = (message: string) => {
    this.props.enqueueSnackbar(message, { variant: 'error' });
  };

  private showSuccess = () => {
    this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
      variant: 'success'
    });
  };

  private renderTimeField = (
    id: string,
    value: number | null,
    isRequired: boolean,
    disabled: boolean,
    onChange: (value: string) => void
  ) => {
    const errorMessages = [
      this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu'),
      this.translatorService.Tranlate(
        'PART_MAPPING_TIME_POSITIVE',
        'Timpul trebuie să fie mai mare decât 0'
      )
    ];

    return (
      <TextValidator
        fullWidth
        name={id}
        id={id}
        disabled={disabled || this.state.isReadOnly}
        value={value ?? ''}
        onChange={(e: any) => onChange(e.target.value)}
        label={this.translatorService.Tranlate('PART_MAPPING_TIME_LABEL', 'Timp (ore)')}
        validators={isRequired && !disabled && !this.state.isReadOnly ? ['required', 'minFloat:0.01'] : []}
        errorMessages={isRequired && !disabled && !this.state.isReadOnly ? errorMessages : []}
        InputProps={{
          inputComponent: this.NumberFormatCustom,
          style: { fontWeight: 500 }
        }}
      />
    );
  };

  private renderDamageSeveritiesForm = (damageType: PartMappingDamageTypeDto, index: number) => {
    const typeSeverities = this.getTypeSeverities(damageType.damageTypeId);
    const isRepair = this.isRepairOperation(damageType.operationId);

    return typeSeverities.map((severity: IReferential) => {
      const selected = damageType.damageSeverities.find(
        (item: PartMappingDamageSeverityDto) => item.damageSeverityId === severity.id
      );

      return (
        <Grid container spacing={2} alignItems="center" key={severity.id}>
          <Grid item xs={7}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={selected !== undefined}
                  disabled={this.state.isReadOnly}
                  onChange={(e: any) =>
                    this.handleDamageSeverityToggle(index, severity.id, e.target.checked)
                  }
                />
              }
              label={this.renderDamageSeverity(severity)}
            />
          </Grid>
          {isRepair ? (
            <Grid item xs={5}>
              {this.renderTimeField(
                `time_${index}_${severity.id}`,
                selected?.time ?? null,
                isRepair,
                selected === undefined,
                (value: string) => this.handleDamageSeverityTimeChange(index, severity.id, value)
              )}
            </Grid>
          ) : null}
        </Grid>
      );
    });
  };

  private renderDamageTypeForm = (damageType: PartMappingDamageTypeDto, index: number) => {
    const required = [
      this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
    ];
    const usedDamageTypeIds = this.state.newPartMapping.damageTypes
      .filter((item: PartMappingDamageTypeDto, itemIndex: number) => itemIndex !== index)
      .map((item: PartMappingDamageTypeDto) => item.damageTypeId);
    const damageTypeOptions = this.state.damageTypeList.filter(
      (item: IReferential) => !usedDamageTypeIds.includes(item.id)
    );
    const selectedDamageType =
      this.state.damageTypeList.find((item: IReferential) => item.id === damageType.damageTypeId) ??
      null;
    const selectedOperation =
      this.state.operationList.find((item: IReferential) => item.id === damageType.operationId) ??
      null;
    const hasSeverities = this.getTypeSeverities(damageType.damageTypeId).length > 0;

    return (
      <Box key={index} mb={2} p={2} border={1} borderColor="grey.300" borderRadius={8}>
        <Grid container spacing={2} alignItems="flex-start">
          <Grid item xs={hasSeverities ? 6 : 4}>
            <Autocomplete
              id={`damageType_${index}`}
              fullWidth
              disabled={this.state.isReadOnly}
              options={damageTypeOptions}
              value={selectedDamageType}
              onChange={(e: any, newValue: IReferential | null) =>
                this.handleDamageTypeChange(index, newValue)
              }
              getOptionLabel={(option: IReferential) => option.displayName || ''}
              renderInput={(params) => (
                <TextValidator
                  {...params}
                  name={`damageType_${index}`}
                  value={selectedDamageType || ''}
                  label={this.translatorService.Tranlate(
                    'PART_MAPPING_DAMAGE_TYPE_LABEL',
                    'Tip daună'
                  )}
                  fullWidth
                  validators={['required']}
                  errorMessages={required}
                />
              )}
            />
          </Grid>
          <Grid item xs={hasSeverities ? 5 : 4}>
            <Autocomplete
              id={`operation_${index}`}
              fullWidth
              disabled={this.state.isReadOnly}
              options={this.state.operationList}
              value={selectedOperation}
              onChange={(e: any, newValue: IReferential | null) =>
                this.handleOperationChange(index, newValue)
              }
              getOptionLabel={(option: IReferential) => option.displayName || ''}
              renderInput={(params) => (
                <TextValidator
                  {...params}
                  name={`operation_${index}`}
                  value={selectedOperation || ''}
                  label={this.translatorService.Tranlate('PART_MAPPING_OPERATION_LABEL', 'Operație')}
                  fullWidth
                  validators={['required']}
                  errorMessages={required}
                />
              )}
            />
          </Grid>
          {!hasSeverities && this.isRepairOperation(damageType.operationId) ? (
            <Grid item xs={3}>
              {this.renderTimeField(
                `time_${index}`,
                damageType.time,
                this.isRepairOperation(damageType.operationId),
                damageType.damageTypeId === null,
                (value: string) => this.handleDamageTypeTimeChange(index, value)
              )}
            </Grid>
          ) : null}
          {!this.state.isReadOnly ? (
            <Grid item xs={1}>
              <IconButton
                aria-label="delete"
                className="text-danger mt-2"
                size="small"
                onClick={() => this.handleRemoveDamageType(index)}
              >
                <DeleteOutlineTwoToneIcon />
              </IconButton>
            </Grid>
          ) : null}
        </Grid>
        {hasSeverities ? this.renderDamageSeveritiesForm(damageType, index) : null}
      </Box>
    );
  };

  public renderAddForm() {
    const { newPartMapping } = this.state;
    const required = [
      this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
    ];
    const bodyType =
      this.state.bodyTypeList.find((item: IReferential) => item.id === newPartMapping.bodyTypeId) ??
      null;
    const part =
      this.state.partList.find((item: IReferential) => item.id === newPartMapping.partId) ??
      null;

    return (
      <ValidatorForm onSubmit={this.savePartMapping} instantValidate={true}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Autocomplete
              id="bodyType"
              fullWidth
              disabled={this.state.isReadOnly}
              options={this.state.bodyTypeList}
              value={bodyType}
              onChange={(e: any, newValue: IReferential | null) =>
                this.handleBodyTypeChange(newValue)
              }
              getOptionLabel={(option: IReferential) => option.displayName || ''}
              renderInput={(params) => (
                <TextValidator
                  {...params}
                  name="bodyType"
                  value={bodyType || ''}
                  label={this.translatorService.Tranlate(
                    'PART_MAPPING_BODY_TYPE_LABEL',
                    'Caroserie'
                  )}
                  fullWidth
                  validators={['required']}
                  errorMessages={required}
                />
              )}
            />
          </Grid>
          <Grid item xs={6}>
            <Autocomplete
              id="part"
              fullWidth
              disabled={this.state.isReadOnly}
              options={this.state.partList}
              value={part}
              onChange={(e: any, newValue: IReferential | null) =>
                this.handlePartChange(newValue)
              }
              getOptionLabel={(option: IReferential) => option.displayName || ''}
              renderInput={(params) => (
                <TextValidator
                  {...params}
                  name="part"
                  value={part || ''}
                  label={this.translatorService.Tranlate('PART_MAPPING_PART_LABEL', 'Piesă')}
                  fullWidth
                  validators={['required']}
                  errorMessages={required}
                />
              )}
            />
          </Grid>
        </Grid>

        <Box mt={3} mb={1} display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6">
            {this.translatorService.Tranlate('PART_MAPPING_DAMAGE_TYPES_TITLE', 'Tipuri de daună')}
          </Typography>
          {!this.state.isReadOnly ? (
            <Button
              variant="outlined"
              color="primary"
              size="small"
              startIcon={<AddIcon />}
              onClick={this.handleAddDamageType}
            >
              {this.translatorService.Tranlate('PART_MAPPING_ADD_DAMAGE_TYPE', 'Adaugă tip daună')}
            </Button>
          ) : null}
        </Box>
        {newPartMapping.damageTypes.map((damageType: PartMappingDamageTypeDto, index: number) =>
          this.renderDamageTypeForm(damageType, index)
        )}

        <div className="text-right">
          <Button className="m-2" variant="outlined" color="default" onClick={this.closeDialog}>
            {this.state.isReadOnly
              ? this.translatorService.Tranlate('PART_MAPPING_CLOSE_BTN', 'Închide')
              : this.translatorService.Tranlate('EDIT_ORGANIZATION_CANCEL_BTN', 'Anuleaza')}
          </Button>
          {!this.state.isReadOnly ? (
            <Button
              className="m-2"
              variant="contained"
              color="secondary"
              type="submit"
              disabled={this.state.isSaving}
              startIcon={
                this.state.isSaving ? <CircularProgress size={16} color="inherit" /> : undefined
              }
            >
              {this.translatorService.Tranlate('EDIT_ORGANIZATION_SAVE_BTN', 'Salveaza')}
            </Button>
          ) : null}
        </div>
      </ValidatorForm>
    );
  }

  private renderTime = (time: number | null) => (time !== null ? ` · ${time} h` : '');

  private renderOperation = (damageType: PartMappingDamageTypeDto) =>
    `· ${damageType.operation?.displayName ?? ''}${
      damageType.operation?.code === GTOperationEnum.RE ? this.renderTime(damageType.time) : ''
    }`;

  private renderDamageTypes = (damageTypes: PartMappingDamageTypeDto[]) => (
    <Box>
      {damageTypes.map((damageType: PartMappingDamageTypeDto) => (
        <Box key={damageType.id} mb={1}>
          <DamageReferentialLabel
            displayName={damageType.damageType?.displayName}
            displayDescription={damageType.damageType?.displayDescription}
            nameSuffix={this.renderOperation(damageType)}
          />
        </Box>
      ))}
    </Box>
  );

  getColumns = () => {
    const columns = [
      {
        name: 'id',
        options: { display: 'excluded', filter: false } as MUIDataTableColumnOptions
      },
      {
        name: 'bodyType',
        label: this.translatorService.Tranlate('PART_MAPPING_BODY_TYPE_LABEL', 'Caroserie'),
        options: {
          customBodyRender: (value: IReferential) => (value ? value.displayName : '')
        } as MUIDataTableColumnOptions
      },
      {
        name: 'part',
        label: this.translatorService.Tranlate('PART_MAPPING_PART_LABEL', 'Piesă'),
        options: {
          customBodyRender: (value: IReferential) => (value ? value.displayName : '')
        } as MUIDataTableColumnOptions
      },
      {
        name: 'damageTypes',
        label: this.translatorService.Tranlate('PART_MAPPING_DAMAGE_TYPES_TITLE', 'Tipuri de daună'),
        options: {
          setCellProps: () => ({ style: { minWidth: 360 } }),
          customBodyRender: (value: PartMappingDamageTypeDto[]) =>
            value ? this.renderDamageTypes(value) : ''
        } as MUIDataTableColumnOptions
      },
      {
        name: 'dateModification',
        label: this.translatorService.Tranlate('USERS_DATE_MODIFICATION_HEADER', 'Data Modificare'),
        options: {
          filter: false,
          customBodyRender: (value: Date) =>
            value ? moment.utc(value).local().format(this.props.appState.longDateFormat) : ''
        } as MUIDataTableColumnOptions
      },
      {
        name: '',
        label: this.translatorService.Tranlate('PART_MAPPING_ACTIONS_LABEL', 'Acțiuni'),
        options: {
          viewColumns: false,
          filter: false,
          sort: false,
          setCellHeaderProps: () => ({ align: 'center' }),
          setCellProps: () => ({ align: 'center' }),
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => {
            return (
              <>
                <IconButton
                  aria-label="view"
                  color="primary"
                  className="text-primary"
                  size="small"
                  onClick={(e) => this.newPartMappingPopup(tableMeta.rowData[0], true)}
                >
                  <VisibilityOutlinedIcon />
                </IconButton>
                <IconButton
                  aria-label="edit"
                  color="primary"
                  className="text-primary"
                  size="small"
                  onClick={(e) => this.newPartMappingPopup(tableMeta.rowData[0])}
                >
                  <EditOutlinedIcon />
                </IconButton>
                <IconButton
                  aria-label="delete"
                  color="inherit"
                  className="text-danger"
                  size="small"
                  onClick={(e) => this.deletePartMapping(e, tableMeta)}
                >
                  <DeleteOutlineTwoToneIcon />
                </IconButton>
              </>
            );
          }
        }
      }
    ];
    return columns;
  };

  deletePartMapping = async (event: any, tableMeta: MUIDataTableMeta) => {
    try {
      const id = tableMeta.rowData[0];
      const response = await this.organizationService.DeletePartMapping(this.organizationId, id);
      if (!response.success) {
        this.showError(this.getSaveErrorMessage(response.message));
        return;
      }

      await this.reloadPartMappings(this.state.page, this.state.pageSize);
      this.showSuccess();
    } catch (error) {
      this.showError(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'));
    }
  };

  newPartMappingPopup = async (partMappingId: number | null, isReadOnly = false) => {
    let newPartMapping: PartMappingDto;
    if (partMappingId == null) {
      newPartMapping = { ...this.state.newPartMapping, damageTypes: [] };
    } else {
      newPartMapping = this.state.partMappingList.find(
        (partMapping: PartMappingDto) => partMapping.id === partMappingId
      )!;
    }
    this.setState({
      isDialogOpen: true,
      isReadOnly: isReadOnly,
      newPartMapping: newPartMapping,
      newPartMappingId: partMappingId
    });
  };

  closeDialog = async () => {
    this.setState({
      isDialogOpen: false,
      isReadOnly: false,
      newPartMapping: { ...this.newPartMapping, organizationId: this.organizationId }
    });
  };

  openImportDialog = async () => {
    this.setState({ isImportDialogOpen: true });
  };

  closeImportDialog = async () => {
    this.setState(
      {
        isImportDialogOpen: false,
        isLoading: true
      },
      async () => {
        await this.reloadPartMappings(0, this.state.pageSize);
      }
    );
  };

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.caseService = (this.context as AppContext).caseService;
    this.organizationService = (this.context as AppContext).organizationService;
    this.appReferentialService = (this.context as AppContext).referentialService;
    const options = {
      filter: false,
      search: false,
      selectableRows: 'none' as SelectableRows,
      selectableRowsOnClick: false,
      print: false,
      download: false,
      textLabels: MUITranslations.GetTranslations(this.translatorService),
      sort: false,
      viewColumns: false,
      elevation: 0,
      serverSide: true,
      count: this.state.count,
      rowsPerPage: this.state.pageSize,
      page: this.state.page,
      onTableChange: async (action: any, tableState: any) => {
        switch (action) {
          case 'changePage':
            await this.reloadPartMappings(tableState.page, tableState.rowsPerPage);
            break;
          case 'changeRowsPerPage':
            await this.reloadPartMappings(tableState.page, tableState.rowsPerPage);
            break;
          default:
        }
      },
      customToolbar: () => {
        return (
          <div>
            <Tooltip title={this.translatorService.Tranlate('Add', 'Adauga')}>
              <IconButton
                aria-label="add"
                color="secondary"
                className="m-2"
                onClick={(e) => this.newPartMappingPopup(null)}
              >
                <AddCircleTwoToneIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title={this.translatorService.Tranlate('Import', 'Importa')}>
              <IconButton
                aria-label="import"
                color="primary"
                className="m-2"
                onClick={(e) => this.openImportDialog()}
              >
                <CloudUploadOutlined />
              </IconButton>
            </Tooltip>
            {this.state.isExporting ? (
              <CircularProgress
                size={20}
                color="primary"
                style={{ verticalAlign: 'middle', marginRight: 4 }}
              />
            ) : null}
            <Tooltip title={this.translatorService.Tranlate('Export', 'Exporta')}>
              <span>
                <IconButton
                  aria-label="export"
                  color="primary"
                  className="m-2"
                  disabled={this.state.isExporting}
                  onClick={(e) => this.handleExport()}
                >
                  <CloudDownloadOutlined />
                </IconButton>
              </span>
            </Tooltip>
          </div>
        );
      }
    };

    return (
      <Fragment>
        <div className="m-3">
          {this.renderFilters()}
          <div className="d-flex flex-row text-center flex-wrap justify-content-center">
            <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
          </div>
          {!this.state.isLoading ? (
            <MUIDataTable
              title={''}
              data={this.state.partMappingList}
              columns={this.getColumns()}
              options={options}
            />
          ) : null}
        </div>
        {this.state.isDialogOpen ? (
          <Dialog
            onClose={this.closeDialog}
            aria-labelledby="customized-dialog-title"
            open={this.state.isDialogOpen}
            fullWidth={true}
            maxWidth={'md'}
          >
            <DialogTitle id="customized-dialog-title">
              <Grid container>
                <Grid item xs={11}>
                  <Typography variant="h4">
                    {this.state.isReadOnly
                      ? this.translatorService.Tranlate('PART_MAPPING_VIEW_MODAL_TITLE', 'Mapare piesă')
                      : !this.state.newPartMappingId
                      ? this.translatorService.Tranlate(
                          'PART_MAPPING_ADD_MODAL_TITLE',
                          'Adaugă mapare piesă'
                        )
                      : this.translatorService.Tranlate(
                          'PART_MAPPING_UPDATE_MODAL_TITLE',
                          'Actualizează mapare piesă'
                        )}
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <IconButton aria-label="close" onClick={this.closeDialog} size={'small'}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </DialogTitle>
            <DialogContent dividers>{this.renderAddForm()}</DialogContent>
          </Dialog>
        ) : null}
        {this.state.isImportDialogOpen ? (
          <PartMappingImport
            open={this.state.isImportDialogOpen}
            organizationId={this.organizationId}
            translatorService={this.translatorService}
            organizationService={this.organizationService}
            caseService={this.caseService}
            onClose={this.closeImportDialog}
          />
        ) : (
          ''
        )}
      </Fragment>
    );
  }
}
export default connect(
  (state: ApplicationState) => ({
    appState: state.app
  }),
  null
)(withSnackbar(PartMappingList as any));
